import React from 'react';

const COLUMNS = [
  { title: 'Platform', links: ['Features', 'Pricing', 'DNS Management', 'NFT Marketplace'] },
  { title: 'Company',  links: ['About', 'Blog', 'Contact', 'Careers'] },
  { title: 'Legal',    links: ['Privacy Policy', 'Terms of Service', 'Cookie Policy'] },
];

/** Standard marketing footer — three link columns + bottom strap. */
export default function Footer({ t }) {
  return (
    <div style={{ borderTop: `1px solid ${t.navBorder}`, padding: '40px 24px', position: 'relative', zIndex: 1 }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 32, marginBottom: 32 }}>
          <div style={{ maxWidth: 280 }}>
            <span style={{ fontSize: 20, fontWeight: 800, background: 'linear-gradient(to right, #A78BFA, #60A5FA)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', display: 'block', marginBottom: 10 }}>TechProOne</span>
            <p style={{ color: t.textMuted, fontSize: 13, lineHeight: 1.7, margin: 0 }}>The modern platform for brand builders. Own your domain, your data, your brand.</p>
          </div>
          <div style={{ display: 'flex', gap: 48, flexWrap: 'wrap' }}>
            {COLUMNS.map((col) => (
              <div key={col.title}>
                <div style={{ color: t.text, fontWeight: 600, fontSize: 13, marginBottom: 12 }}>{col.title}</div>
                {col.links.map((link) => (
                  <div
                    key={link}
                    style={{ color: t.textMuted, fontSize: 13, marginBottom: 8, cursor: 'pointer', transition: 'color 0.2s' }}
                    onMouseEnter={(e) => { e.currentTarget.style.color = '#A78BFA'; }}
                    onMouseLeave={(e) => { e.currentTarget.style.color = t.textMuted; }}
                  >
                    {link}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
        <div style={{ borderTop: `1px solid ${t.navBorder}`, paddingTop: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
          <span style={{ color: t.textMuted, fontSize: 12 }}>© 2026 TechProOne. All rights reserved.</span>
          <span style={{ color: t.textMuted, fontSize: 12 }}>Built with ❤️ for brand builders worldwide</span>
        </div>
      </div>
    </div>
  );
}
